import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  env = environment;
  currentYear:any;

  ngOnInit(){
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();

  }

}
